import Form from '../../common/form';
import PropTypes from 'prop-types';
import Joi from 'joi';

class MTSummaryForm extends Form {
	state = {
		data: {
			general: '',
			remarks: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		general: Joi.string().min(10).required().label('Anomaly Report'),
		remarks: Joi.string().min(10).required().label('Remarks'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({
			data: {
				general: '',
				remarks: '',
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderTextArea({
							name: 'general',
							label: 'Anomaly Report',
							rows: '6',
							placeholder: 'Enter at least 10 characters',
						})}
					</div>

					<div className="col">
						{this.renderTextArea({
							name: 'remarks',
							label: 'Remarks',
							rows: '6',
							placeholder: 'Enter at least 10 characters',
						})}
					</div>
				</div>

				{this.renderButton('Proceed')}
			</form>
		);
	}
}

export default MTSummaryForm;
